<template>
	<div>
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top head-title="分销记录" goBack="true"></head-top>
		<div class="screen bg_a flex_c">
			<div @click="show = true" class="font_size_b flex_a">
				<div>{{date}}</div>
				<img :src='resourceDomain+"static/icon/xiala.png"' class="xialaicon">
			</div>
			<div class="font_size_b color_f">
				￥ <span class="color_d distribution_amount">{{totalCommission}}</span>
			</div>
		</div>

		<!-- 日历 -->
		<van-calendar v-model="show" type="range" @confirm="onConfirm" :allow-same-day="true" :min-date="minDate" :max-date="maxDate" ref="calendar" :max-range="365" :default-date="defaultDate"/>

		<div class="paddingtopa">
			<!-- 账单流水列表 -->
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<van-list :offset="40" v-model="loading" :finished="finished" :immediate-check="false" :finished-text="finishedText" @load="onLoad" v-if="orderList.length > 0">
					<div  class="ordersList">
						<div v-for="(item, index) in orderList" :key="index" class="orders_item bg_a">
							<div class="orders_item_top flex_c font_size_a">
								<div class="color_c fw">{{item.buyerLoginAccount}}</div>
								<div class="color_f font_size_e">
									<span v-if="item.payOrCancelStatus==1">支付时间：</span>
								<span v-if="item.payOrCancelStatus==2">退货时间：</span>
								{{item.payOrCancelTime}}
								</div>
							</div>
							<div class="order_list">
								<div v-for="item1 in item.bookOrderItemModelList" :key="item1.orderItemId" class="order_item">
									<div class="ellipsis_1 font_size_a">{{item1.bookName}}</div>
									<div class="flex_a order_item_about" style="justify-content: flex-end;">
										<div class="color_d" style="width: 70%;" v-if="item1.commission">￥<span class="font_size_a">{{item1.commission}}</span></div>
										<div class="color_d" style="width: 70%;" v-else>不参与分销</div>
										<div class="color_f font_size_b" style="width:30%;" v-if="item.payOrCancelStatus==1">x {{item1.bookCount}}</div>
										<div class="color_f font_size_b" style="width:30%;" v-if="item.payOrCancelStatus==2">x {{item1.cancelNumber}}</div>
									</div>
								</div>
							</div>
							<div class="order_list color_f font_size_b" style="border:unset;text-align:right">
								<span v-if="item.payOrCancelStatus==1">总提成</span>
								<span v-if="item.payOrCancelStatus==2">总退款</span>
								：￥ <span class="color_d totalDistributionAmount">{{item.totalDistributionAmount}}</span>
							</div>
						</div>
					</div>
				</van-list>
				<div v-else class="color_e font_size_c paddinga" style="text-align:center;">
					<img :src='resourceDomain+"static/icon/no_order.png"' class="noorderimg">
					暂无数据，逛逛别的分类吧~
				</div>
			</van-pull-refresh>
		</div>

	</div>
</template>

<script>
	import headTop from "@/components/common/head.vue";
	import api from "@/apis/api";
	import tool from "@/common/tool";
	import {
		mapGetters
	} from "vuex";

	export default {
		name: "DistributionBill",
		components: {
			headTop: headTop,
		},
		data() {
			return {
				date: `${this.dateFormat(new Date())} ~ ${this.dateFormat(new Date())}`,
				show: false,
				minDate: new Date(2021, 5, 4), //最小可选日期，月份要少写一个月（2021, 5,4）
				maxDate: new Date(), //最大可选日期
				startTime: "", //开始时间
				endTime: "", //结束时间
				totalCommission:0,//分销筛选总金额
				defaultDate:[new Date(),new Date()],//默认选中当天

				resourceDomain: api.resourceDomain,
				orderList: [],
				page: 0,
				pages: undefined,
				isLoading: false,
				loading: false,
				finished: false,
				finishedText: ""
			};
		},
		beforeRouteEnter(to, from, next) {
			// 添加背景色
			document.querySelector('body').setAttribute('style', 'background-color:#f5f5f5')
			next()
		},
		beforeRouteLeave(to, from, next) {
			// 去除背景色
			document.querySelector('body').setAttribute('style', '')
			next()
		},
		created() {
			
		},
		activated() {
			this.updatePage()
		},
		methods: {
			// 调用组件中的登录成功里的自定义的更新数据事件
						updatePage() {
							this.$refs.calendar.reset();
							this.date = `${this.dateFormat(new Date())} ~ ${this.dateFormat(new Date())}`
							this.show = false
							this.startTime=this.dateFormat(new Date())
								this.endTime=this.dateFormat(new Date())
								this.totalCommission=0
							this.maxDate = new Date() //最大可选日期
							
							this.orderList = []
							this.page = 0
							
							this.pages=0
							this.isLoading=false
							this.loading= false
							this.finished=false
							this.finishedText=""
							
							this.getOrderList()
						},
						
			//年月日
			dateFormat(time) {
				var year = time.getFullYear()
				var month = (time.getMonth() + 1) > 9 ? (time.getMonth() + 1) : `0${time.getMonth()+1}`
				var date = (time.getDate()) > 9 ? (time.getDate()) : `0${time.getDate()}`
				return `${year}-${month}-${date}`
			},

			// 选择时间
			onConfirm(date) {
				console.log("date")
				const [start, end] = date;
				this.show = false;
				this.date = `${this.dateFormat(start)} ~ ${this.dateFormat(end)}`;
				this.startTime = this.dateFormat(start)
				this.endTime = this.dateFormat(end)
				console.log(this.date, "--------------------date选择时间")
				this.page = 0;
				this.orderList = [];
				this.loading = true
				this.finished = false
				this.getOrderList()
			},

			// 获取订单列表
			getOrderList() {
				let orderList = this.orderList;
				let page = this.page + 1;
				api
					.post("/distributorBookOrderRelation/getOrderList", {
						page: page,
						size: 5,
						startTime: this.startTime,
						endTime: this.endTime
					})
					.then((res) => {
						this.$toast.clear();
						console.log(res, "-----getOrderList------");
						if (res.code == 20000) {
							if (res.data.total > 0) {
								for (var i = 0; i < res.data.bookOrderList.length; i++) {
									orderList.push(res.data.bookOrderList[i]);
								}

								this.orderList = orderList;
								this.page = page;
								this.pages = res.data.pages;
								if(res.data.totalCommission){
									this.totalCommission=(res.data.totalCommission).toFixed(2)
								}else{
									this.totalCommission=0
								}
								// 加载状态结束
								this.isLoading = false
								this.loading = false
								// 设置是否可以继续上拉加载
								if (this.page == this.pages) {
									this.finished = true
								} else {
									this.finished = false
								}
								this.finishedText = "没有更多了~"
							} else {
								this.finished = true
								this.finishedText = ""
								this.orderList = []
								this.totalCommission=0
							}
						} else {
							this.$toast(res.message);
						}
					});
			},
			/**下拉刷新 */
			onRefresh() {
				this.page = 0;
				this.orderList = [];
				this.getOrderList();
				this.isLoading = false;
			},
			/**上拉加载 */
			onLoad() {
				if (this.page >= this.pages) {
				} else {
					this.getOrderList()
				}
			},

		},
	};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
	/* 图书 */
	/* 搜索开始 */
	.paddingtopa {
		padding-top: 93px;
	}

	.paddinga {
		text-align: center;
		padding: 15px 0;
	}

	.noorderimg {
		display: block;
		width: 345px;
		height: 172.5px;
		margin: 12vh auto 25px;
	}

	.screen {
		padding: 0 15px;
		width: 345px;
		position: fixed;
		left: 0;
		top: 48px;
		z-index: 999;
		height: 45px;
	}

	.screen div {
		line-height: 45px;
	}

	.distribution_amount {
		font-size: 24px;
	}
	.totalDistributionAmount{
		font-size: 20px;
	}

	.xialaicon {
		width: 10px;
		height: 6px;
		margin-left: 5px;
		display: block;
	}

	.ordersList {
		padding: 0 15px 10px;
		width: 345px;
	}
	.orders_item{
		border-radius:5px;
		margin-top:10px;
		border:1px solid #eee;
		padding-bottom:10px;
	}
	.orders_item_top{
		padding:10px 15px;
		border-bottom:1px solid #eee;
	}
	.order_list{
		padding:10px 15px 0;
		border-bottom:1px solid #eee;
	}
	.order_item{
		margin-bottom:12px;
	}
	.order_item_about{
		padding-top:6px;
		font-size:10px;
		text-align:right;
	}
</style>
